import React from "react";

export const BikeSvg = ({ width, height, fill }) => {
  return (
    <svg
      fill={fill ?? "#fff"}
      width={width}
      height={height}
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 488.146 488.146"
    >
      <g>
        <g>
          <path
            d="M394.553,223.652c-1.98-0.744-4.205-1.041-6.642-0.807c-0.33-0.031-0.666-0.031-1.001-0.056
			c-6.124-29.915-11.445-59.997-16.412-90.149c17.204-4.073,32.073-14.498,39.726-31.59c3.26-7.279,2.178-15.673-5.251-20.024
			c-6.317-3.702-16.763-2.034-20.022,5.253c-5.769,12.867-15.782,18.812-29.808,19.098c-3.824,0.079-6.83,1.378-9.104,3.344
			c-4.469,3.155-7.552,8.455-6.47,15.183c2.509,15.655,5.104,31.298,7.825,46.908c-45.469-3.266-90.997-2.679-136.549-2.526
			c-0.531-4.753-0.594-9.575-0.599-14.612c0-0.853-0.125-1.627-0.239-2.404c1.543-0.165,3.077-0.383,4.628-0.523
			c18.646-1.675,18.807-30.96,0-29.274c-18.631,1.673-36.958,4.844-55.119,9.3c-18.329,4.499-10.552,32.73,7.779,28.231
			c4.56-1.117,9.125-2.138,13.701-3.095c0.058,8.123,0.441,16.313,2.173,24.258c-15.982,18.56-31.854,37.206-47.499,56.041
			c-12.429-6.266-26.032-10.524-39.702-12.548c-1.98-0.744-4.207-1.041-6.64-0.807c-6.099-0.576-12.18-0.734-18.131-0.384
			c-7.233,0.422-11.664,5.038-13.335,10.481c-32.445,15.848-55.111,46.107-57.701,84.578c-3.329,49.379,45.191,89.145,91.548,91.379
			c48.353,2.325,86.671-29.117,95.844-74.799c-0.157,1.26,28.452-3.768,30.138-4.037c15.993-2.56,25.624-5.002,38.065-16.133
			c18.057-16.143,34.443-34.662,50.911-52.399c6.535-7.033,49.175-45.049,47.591-53.329c1.32,6.901,2.682,13.797,4.083,20.686
			c-0.817,1.254-1.458,2.615-1.895,4.039c-32.448,15.863-55.106,46.123-57.701,84.594c-3.331,49.379,45.189,89.145,91.546,91.379
			c51.836,2.498,92.166-33.799,97.396-84.868C493.421,268.066,444.404,231.03,394.553,223.652z M141.233,275.333
			c7.909,8.013,13.812,18.077,16.755,30.229c-13.787,0.208-27.581,0.248-41.375,0.273
			C124.75,295.614,132.956,285.448,141.233,275.333z M88.407,379.178c-34.261-4.651-63.446-32.865-58.351-68.67
			c4.501-31.636,31.344-51.155,60.364-58.173c9.245,1.071,18.179,3.372,26.416,6.824c-12.964,15.904-25.824,31.89-38.427,48.084
			c-2.019,2.59-3.021,5.367-3.275,8.109c-0.63,1.614-1.013,3.352-1.013,5.169c0,7.973,6.655,14.635,14.637,14.635H99
			c1.78,0,3.474-0.37,5.065-0.975c1.544,0.568,3.225,0.975,5.18,0.975c16.379,0,32.748-0.081,49.106-0.324
			C150.899,364.391,118.931,383.321,88.407,379.178z M188.854,304.785c-2.714-21.068-13.625-38.669-28.891-52.176
			c10.047-12.053,20.274-23.956,30.46-35.894c7.831,28.84,15.069,57.826,21.559,87.008
			C204.276,304.15,196.565,304.511,188.854,304.785z M238.71,289.322c-6.979-30.792-14.79-61.372-23.211-91.794
			c36.109-0.137,72.204-0.447,108.263,1.173C296.426,229.875,268.361,260.348,238.71,289.322z M386.992,379.178
			c-34.261-4.646-63.449-32.865-58.351-68.67c3.225-22.652,17.92-39.06,36.652-49.14c4.205,18.657,8.734,37.252,13.792,55.731
			c4.972,18.189,33.21,10.455,28.224-7.785c-5.108-18.677-9.679-37.47-13.919-56.33c33.53,5.322,62.327,26.563,65.115,64.663
			C461.369,356.753,423.107,384.078,386.992,379.178z"
          />
        </g>
      </g>
    </svg>
  );
};
